/**
 * Format the number to be always with 2 digits
 * @param {number} number 
 * @param {number} minCharacters 
 * @returns number
 */
export const addLeadingZeroes = (number, minCharacters) => {
    let numberToSlice = '';
    for (let i = 0; i < minCharacters; i++) {
        numberToSlice = numberToSlice + '0';
    }
    return (numberToSlice + number).slice(-minCharacters);
};

/**
 * Standart validation
 * @param {string} email 
 * @returns boolean
 */
export const validateEmail = (email) => {
    if (!email.trim().length) {
        return null;
    }

    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
        );
};

/**
 * Because of the storaging the user in local storage
 * here is global method to clear the user data
 */
export const clearStorageUserData = () => {
    localStorage.removeItem('shishiPlayerInfo');
    localStorage.removeItem('shishiSelectedOffer');
    localStorage.removeItem('adyen-checkout__session');
    localStorage.removeItem('shishiFilters');
};

/**
 * Returns an object of key-value pairs for the query params
 * Strips the leading ? or #
 * example query:
 *      #param1=2&param2=4
 *      ?param1=2&param2=4
 * @param query
 */
export const getQueryParams = (query) => {
    if (query) {
        query = query.slice(1);
        query = query.replace('&amp;', '&');
        return query.split('&').reduce((prev, current) => {
            const [currentParam, currentValue] = current.split('=');
            return {
                ...prev,
                [currentParam]: decodeURIComponent(currentValue)
            }
        }, {});
    }
};

/**
 * Detects if the device is Apple
 * @returns boolean
 */
export const isAppleDevice = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod|macintosh/.test(userAgent);
}

/**
 * Detects if browser is Safari
 * @returns boolean
 */
export const isSafariBrowser = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    return /safari/.test(userAgent) && !/chrome|firefox|opera|edge|ie/.test(userAgent);
}

/**
 * Disable the whole acrolling of the app
 */
export const disableScrolling = () => {
    document.body.style.overflow = 'hidden';
}

/**
 * Enable the whole acrolling of the app
 */
export const enableScrolling = () => {
    document.body.style.overflow = 'auto';
}

/**
 * Open the URL in a new tab
 * @param {string} url
 */
export const openUrlInNewTab = (url) => {
    if (url && url.trim().length > 0) {
        window.open(url, '_blank');
    } else {
        console.error('You are trying to open an empty URL in a new tab');
    }
}
